import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';
import { TakeSkipFilter } from '@typings';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

export async function getAllSegments(params?: TakeSkipFilter): Promise<any> {
  let where = {};
  if (!!params?.filter && !!Object.keys(params.filter).length) {
    Object.keys(params.filter).forEach(key => {
      if (params?.filter?.[key]) {
        where = {
          ...where,
          [key]: params.filter[key],
        };
      }
    });
  }

  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/segments`,
    method: 'GET',
    params: {
      where: JSON.stringify(where),
      take: params?.take || 10,
      skip: params?.skip || 0,
      returnCount: true,
    },
  });

  if (!data) {
    throw Error(data.message);
  }

  return data;
}
